<template>
  <v-container grid-list-md fluid ma-0 class="header-container">
    <v-layout row wrap>
      <v-flex xs12 pa-3 class="header-content text-xs-center white--text headline font-weight-medium">
        Practices
      </v-flex>
      <utility-backButton/>
      <v-dialog persistent v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>
            Editing Practice: {{selectedPractice.Name}}
            <v-spacer/>
            <v-icon @click="cancelEdit" color="pipefishOrange" medium>mdi-close-circle-outline</v-icon>
          </v-card-title>
          <v-card-text style="padding:2px">
            <v-form ref="form" v-model="validation">
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs6 pr-5>
                    <v-text-field
                      label="Practice Name"
                      v-model="selectedPractice.Name"
                      :rules="nameRules"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Practice Code"
                      v-model="selectedPractice.Code"
                      :rules="codeRules"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                      label="Active"
                      v-model="selectedPractice.IsActive"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      :items="projectLeads"
                      label="Project Lead"
                      v-model="selectedPractice.projectLead"
                      :rules="[!!selectedPractice.projectLead || 'Select a project lead']"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="pipefishOrange" @click="cancelEdit">Cancel</v-btn>
            <v-btn :loading="showLoading" color="pipefishGreen" @click="saveEdit" :disabled="showLoading || !validation">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-flex xs12>
        <v-card-title>
          <!-- <span class="title font-weight-bold"> Practices </span> -->
          <v-spacer></v-spacer>
          <div>
            <v-flex xs12>
              <v-select
                dense
                hide-details
                :items="[{text: 'Active', value: false},
                {text: 'InActive', value: true},
                {text: 'Both', value: 'Both'}]"
                label="Filter on"
                v-model="filterActive"
              >
              </v-select>
            </v-flex>
          </div>
          <div>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            color="pipefishGreen"
          >
            <template slot="label">
              <span>Search</span>
            </template>
          </v-text-field>
          </div>
          <v-card-actions>
            <v-spacer/>
            <v-btn  left color="pipefishGreen" @click="addPractice">Add</v-btn>
          </v-card-actions>
        </v-card-title>
        Total Shown: {{displayPractices.length}}
        <v-data-table
          v-if="practices != null"
          :headers="headers"
          :items="displayPractices"
          :search="search"
          sort-icon="mdi-menu-down"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{props.item.Name}}</td>
            <td>{{props.item.Code}}</td>
            <td v-if="props.item.projectLead">{{props.item.projectLead.GivenName}} {{props.item.projectLead.Surname}}</td>
            <td v-else style="color:red"> No Project Lead</td>
            <td>{{props.item.IsActive ? "active" : "inactive"}}</td>
            <td class="text-xs-right"><utility-editButton @edit="editPractice(props.item)"/></td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
    
</template>

<script>
import {
  mapState,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data: () =>({
    filterActive: false,
    nameRules: [
      v => !!v || 'Practice Name is required'
    ],
    codeRules: [
      v => !!v || 'Practice Code is required'
    ],
    validation: true,
    search:'',
    isEdit: false,
    dialog: false,
    showLoading: false,
    selectedPractice: {},
    originalPractice: {},
    headers: [
      {text: 'Name', value: 'Name'},
      {text: 'Code', value: 'Code', sortable: false},
      {text: 'Project Lead', value: 'projectLead.GivenName'},
      {text: 'Active', value: 'IsActive', sortable: false},
      {text: 'Action', value: 'action', align: 'right'}
    ]
  }),
  computed: {
    ...mapState('admin', ['pipefishUsers', 'practices']),
    projectLeads: function() {
      return this.pipefishUsers.map(user => ({text: `${user.GivenName} ${user.Surname}`, value: user}))
    },
    displayPractices: function() {
      return this.practices.filter(practice => practice.IsActive != this.filterActive)
    }

  },
  created() {
    var self = this
    // get all practices if they aren't already retreived
    if(this.practices.length == 0) {
      this.$timesheetApi.getPractices().then(response => {
        self.setPractices(response)
      })
    }

    // get all users if they aren't already retreived
    if(this.pipefishUsers.length == 0) {
      this.$timesheetApi.getAllUsers().then(response => {
        self.setSortedPipefishUsers(response)
      })
    }
  },
  methods: {
    ...mapMutations('admin', ['setPractices']),
    ...mapMutations('api', ['setTimesheetData']),
    ...mapActions('admin', ['setSortedPipefishUsers']),
    editPractice(practice) {
      this.isEdit = true
      this.showLoading = false
      Object.assign(this.selectedPractice, practice)
      delete this.selectedPractice.projectLead.ExternalIdentifier
      delete this.selectedPractice.projectLead.IsAdmin
      delete this.selectedPractice.projectLead.createdAt
      delete this.selectedPractice.projectLead.updatedAt
      this.dialog = true
    },
    addPractice() {
      this.$refs.form.resetValidation()
      this.showLoading = false
      this.isEdit = false
      this.dialog = true
      this.selectedPractice = {IsActive: true}
    },
    saveEdit() {
      this.showLoading = true
      var self = this
      if(this.isEdit) {
        // Editing an existing Practice
        this.$timesheetApi.updatePractice(this.selectedPractice).then(response => {
          // console.log(response)
          self.$timesheetApi.getPractices().then(res => {
            self.setPractices(res)
            self.dialog = false
          })
          self.$timesheetApi.getData().then(masterData => {
            self.setTimesheetData(masterData)
          })
        })

      } else {
        // Adding a new Practice
        this.$timesheetApi.addPractice(this.selectedPractice).then(response => {
          // console.log(response)
          self.$timesheetApi.getPractices().then(res => {
            self.setPractices(res)
            self.dialog = false
          })
          self.$timesheetApi.getData().then(masterData => {
            self.setTimesheetData(masterData)
          })
        })
      }
    },
    cancelEdit() {

      this.dialog = false
    }
  }

}
</script>

<style>

</style>
